import merge from "lodash/merge";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var currencyGoalInvestmentItemBalanceEntities = function currencyGoalInvestmentItemBalanceEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byGoalIdAndDateAndInvestmentItemNotCurrency: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_GOALVIEWBYGOALIDANDAUTHUSERID_SUCCESS:
      var byGoalIdAndDateAndInvestmentItemNotCurrency = action.response.currencyGoalInvestmentItemBalancesByGoalIdAndDateAndInvestmentItemNotCurrency;
      return merge({}, state, {
        byGoalIdAndDateAndInvestmentItemNotCurrency: byGoalIdAndDateAndInvestmentItemNotCurrency
      });
    default:
      return state;
  }
};
export default currencyGoalInvestmentItemBalanceEntities;